import React from "react";

const Icon5 = ({ className }) => {
  return (
    <svg
      className={`icon-5 ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 25 24"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="g" clipPath="url(#clip0_332_250)">
        <path
          className="path"
          d="M4.49999 14C4.31076 14.0007 4.12522 13.9476 3.96495 13.847C3.80467 13.7464 3.67623 13.6024 3.59454 13.4317C3.51286 13.261 3.48129 13.0706 3.50349 12.8827C3.5257 12.6948 3.60077 12.517 3.71999 12.37L13.62 2.17004C13.6943 2.08432 13.7955 2.0264 13.907 2.00577C14.0185 1.98515 14.1337 2.00305 14.2337 2.05654C14.3337 2.11004 14.4126 2.19594 14.4573 2.30015C14.5021 2.40436 14.5101 2.52069 14.48 2.63004L12.56 8.65004C12.5034 8.80156 12.4844 8.96456 12.5046 9.12505C12.5248 9.28553 12.5837 9.43872 12.6761 9.57147C12.7685 9.70421 12.8918 9.81256 13.0353 9.8872C13.1788 9.96185 13.3382 10.0006 13.5 10H20.5C20.6892 9.9994 20.8748 10.0525 21.035 10.1531C21.1953 10.2537 21.3238 10.3977 21.4054 10.5684C21.4871 10.7391 21.5187 10.9295 21.4965 11.1174C21.4743 11.3053 21.3992 11.4831 21.28 11.63L11.38 21.83C11.3057 21.9158 11.2045 21.9737 11.093 21.9943C10.9815 22.0149 10.8663 21.997 10.7663 21.9435C10.6663 21.89 10.5874 21.8041 10.5427 21.6999C10.4979 21.5957 10.4899 21.4794 10.52 21.37L12.44 15.35C12.4966 15.1985 12.5156 15.0355 12.4954 14.875C12.4752 14.7145 12.4163 14.5614 12.3239 14.4286C12.2315 14.2959 12.1082 14.1875 11.9647 14.1129C11.8212 14.0382 11.6617 13.9995 11.5 14H4.49999Z"
          stroke="#0071E7"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>

      <defs className="defs">
        <clipPath className="clip-path" id="clip0_332_250">
          <rect
            className="rect"
            fill="white"
            height="24"
            transform="translate(0.5)"
            width="24"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Icon5;